import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import {
  getAlgoRefreshFlat,
  getFilter,
} from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';
import { sortNumerically } from '../../../../../helpers/table-filters/sort/sortNumerically';

function useOptions() {
  const options = [
    {
      label: '1x',
      value: 1,
    },
  ];
  const data = useSelector(getAlgoRefreshFlat);
  const sortedData = sortNumerically(data, 'multiplier', 'ASC');

  sortedData.forEach((item) => {
    if (
      item.multiplier &&
      !options.some((option) => option.value === item.multiplier)
    ) {
      options.push({
        value: item.multiplier,
        label: `${item.multiplier}x`,
      });
    }
  });

  return options;
}

const ViewMultiplier = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.multiplier ? true : false;
  const options = useOptions();

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={options}
          viewsFilter={viewsFilter}
          fieldName="multiplier"
          title="Filter Multiplier:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewMultiplier;
